/* USP-balk: onder 1280 px één belofte tegelijk.
   Wisselt elke 4 seconden; pauzeert zolang je de balk aanraakt, erover beweegt of erin tabt.
   Bij 'minder beweging' niet: dan blijft de veegbare rij staan. */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 1279px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(list) {
    if (list.dataset.uspInit) return;
    list.dataset.uspInit = '1';
    var items = list.querySelectorAll('.usp-bar__item');
    if (items.length < 2) return;
    var index = 0;
    var timer = null;
    var paused = false;

    function show(i) {
      items.forEach(function (item, n) { item.classList.toggle('is-active', n === i); });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      timer = setInterval(function () {
        if (paused || document.hidden || !list.isConnected) return;
        index = (index + 1) % items.length;
        show(index);
      }, 4000);
    }
    function update() {
      if (mq.matches && !reduce.matches) {
        list.classList.add('is-rotating');
        show(index);
        start();
      } else {
        stop();
        list.classList.remove('is-rotating');
        items.forEach(function (item) { item.classList.remove('is-active'); });
      }
    }

    ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
      list.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) {
      list.addEventListener(ev, function () { paused = false; }, { passive: true });
    });
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
      reduce.addEventListener('change', update);
    }
    update();
  }

  function init() { document.querySelectorAll('.usp-bar__list').forEach(setup); }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
